import { render, staticRenderFns } from "./NewTag.vue?vue&type=template&id=59fb792c&scoped=true&"
import script from "./NewTag.vue?vue&type=script&lang=js&"
export * from "./NewTag.vue?vue&type=script&lang=js&"
import style0 from "./NewTag.vue?vue&type=style&index=0&id=59fb792c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fb792c",
  null
  
)

export default component.exports